import {
  loginLogic,
  logoutLogic,
  clearAuthenticationLogic,
  dismissSearchMessagingLogic,
  dismissLoginTooltipLogic,
  dismissWelcomeMessageLogic,
  locationChangeLogic,
} from './userLogic';

export const logic = [
  dismissSearchMessagingLogic,
  loginLogic,
  logoutLogic,
  clearAuthenticationLogic,
  dismissLoginTooltipLogic,
  dismissWelcomeMessageLogic,
  locationChangeLogic,
];
